var _sentryCollisionFreeGlobalObject = typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : {};
_sentryCollisionFreeGlobalObject["__sentryRewritesTunnelPath__"] = undefined;
_sentryCollisionFreeGlobalObject["SENTRY_RELEASE"] = {"id":"b78f9263a0d21652db506953c3801d24bd8b1fed"};
_sentryCollisionFreeGlobalObject["__sentryBasePath"] = undefined;
_sentryCollisionFreeGlobalObject["__rewriteFramesAssetPrefixPath__"] = "";

import * as Sentry from '@sentry/nextjs';
import {
  dsn,
  replaysOnErrorSampleRate,
  replaysSessionSampleRate,
  sentryEnabled,
  sentryEnvironment,
  tracesSampler,
} from './utils/sentry';

Sentry.init({
  dsn,
  // Replay may only be enabled for the client-side
  integrations: [Sentry.replayIntegration()],
  environment: sentryEnvironment,
  enabled: sentryEnabled,
  tracesSampler,
  replaysSessionSampleRate,
  replaysOnErrorSampleRate,
});
